import type { DriverJsContextType } from './DriverJsProvider'
import { use } from 'react'
import { DriverJsContext } from './DriverJsProvider'

export function useDriverJs(): DriverJsContextType | null {
  const context = use(DriverJsContext)

  if (!context) {
    if (import.meta.env.DEV) {
      console.warn('useDriverJs must be used within a DriverJsProvider')
      return {
        startTutorial: async () => {},
        endTutorial: () => {},
        isActive: false,
        isStartingTutorial: false,
        showTutorialModal: false,
        tutorialOrderId: null,
      } as any
    }
    throw new Error('useDriverJs must be used within a DriverJsProvider')
  }

  return context
}
